import TitleWithAutomaticGeneration from './TitleWithAutomaticGeneration';



export default TitleWithAutomaticGeneration;
